import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useControlled } from '../../../../internal/hooks';
export function useOpenCloseControlled(props) {
  var onOpen = props.onOpen,
    onClose = props.onClose;
  var _useControlled = useControlled({
      controlled: props.open,
      default: false
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    open = _useControlled2[0],
    setOpen = _useControlled2[1];
  var handleOpen = React.useCallback(function () {
    setOpen(true);
    if (onOpen) {
      onOpen();
    }
  }, [onOpen, setOpen]);
  var handleClose = React.useCallback(function () {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);
  return {
    open: open,
    handleClose: handleClose,
    handleOpen: handleOpen
  };
}